import * as Sentry from '@sentry/react';
import { isEmpty } from 'lodash';
import { useQuery } from 'react-query';
import { queryGet } from '../../../utils/queryClient';
import type { UserDataType } from '../../types/UserType';

interface UserResponse {
  user: UserDataType;
}

export default function useUserQuery() {
  const userQuery = useQuery<UserResponse, Error, UserDataType>(
    ['users'],
    () => queryGet('/api/v1/users'),
    {
      select: (data) => data.user,
      cacheTime: 60 * 10 * 1000,
      staleTime: 60 * 10 * 1000
    }
  );

  if (!isEmpty(userQuery.data)) {
    Sentry.setUser({
      id: userQuery.data.userId,
      email: userQuery.data.email
    });
  }

  return userQuery;
}
